const shifts = {
  form: {
    information: {
      directionOptions: {
        from: 'De la escuela',
        to: 'Hacia la escuela',
        both: 'Hacia la escuela & De la escuela',
      },
    },
  },
};

export default shifts;
